import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ForestOwnerName from "../../components/forestOwner/ForestOwnerDetail/ForestOwnerName.tsx";
import {useLocationFormState} from "../../components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm";
import ForestOwnerUpdateFormProvider from "../../components/forestOwner/ForestOwnerForm/ForestOwnerUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ForestOwnerUpdateEditPage = () => {
    
    useTitle(t`Update Forest Owner`);

    const { forestOwnerId: id } = useParams();
    
    return (
        <Box data-testid="ForestOwner-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ForestOwner-update-title"
                    >
                        <Trans>Edit Forest Owner</Trans>:  <ForestOwnerName id={id}/>
                    </Typography>
                    <ForestOwnerUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ForestOwnerUpdateEditPage;
